import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Miami.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Ensure a High Return with Customized Business Software</h2>
            <p>
              Miami's emergence as a tech hub demands a forward-thinking
              approach to software development, and that's precisely where we
              come in.
            </p>
            <p>
              As a leading custom software development company in Miami, we
              understand that businesses in Miami need more than
              one-size-fits-all solutions. We provide customized software
              transformation strategies that align with your unique needs and
              goals.
            </p>
            <p>
              Our commitment goes beyond coding; we empower businesses to access
              the tech world with confidence.
            </p>
            <p>
              We stay ahead of the curve, utilizing the latest technologies,
              industry trends, and local market insights to drive efficiency,
              innovation, and sustainable growth.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
